import React, { useEffect, useState } from "react";
import { FileDown, Shield, FileText } from "lucide-react";
import api from "../lib/api";

export default function Terms() {
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    api.get("/documents").then((r) => setDocs(r.data));
  }, []);

  const buildUrl = (u) => {
    if (!u) return "#";
    if (u.startsWith("http")) return u;
    return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  };

  return (
    <div data-testid="terms-page" className="bg-[#2A2A2A] min-h-screen">
      <header className="bg-[#1F1F1F] border-b border-[#3a3a3a] py-20">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="kicker mb-5">Dokumenty</div>
          <h1 className="font-display text-white text-5xl md:text-7xl uppercase leading-[0.9]">
            Regulamin<br/><span className="text-[#FFCC00]">& RODO</span>
          </h1>
        </div>
      </header>

      <section className="py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-10">
          <div className="space-y-5" data-testid="documents-list">
            <div className="kicker mb-2">Dokumenty do pobrania</div>
            {docs.length === 0 ? (
              <p className="text-white/50">Brak dokumentów.</p>
            ) : (
              docs.map((d, i) => (
                <article
                  key={d.id}
                  className="bg-[#1F1F1F] border border-[#3a3a3a] p-7 noise relative hover:border-[#FFCC00] transition-colors"
                  data-testid={`document-${i}`}
                >
                  <div className="flex items-start gap-4">
                    <FileText className="text-[#FFCC00] flex-shrink-0" size={36}/>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-display text-white text-xl uppercase">{d.title}</h3>
                      {d.description && (
                        <p className="text-white/65 text-sm mt-2 leading-relaxed">{d.description}</p>
                      )}
                      <a
                        href={buildUrl(d.file_url)}
                        target="_blank"
                        rel="noreferrer"
                        download
                        data-testid={`download-document-${i}`}
                        className="mt-4 inline-flex items-center gap-2 bg-[#FFCC00] text-[#2A2A2A] font-display text-xs px-5 py-3 btn-brutal"
                      >
                        <FileDown size={14}/> POBIERZ PDF
                      </a>
                    </div>
                  </div>
                </article>
              ))
            )}
          </div>

          <div className="bg-[#1F1F1F] border border-[#3a3a3a] p-10 h-fit">
            <Shield className="text-[#FFCC00] mb-4" size={40}/>
            <div className="kicker mb-4">Ochrona danych osobowych</div>
            <h2 className="font-display text-white text-2xl uppercase mb-4">RODO — informacja</h2>
            <ul className="space-y-3 text-white/75 text-sm leading-relaxed">
              <li>• Administratorem danych jest Śląski Maker Space, ul. Plebiscytowa 15, 40-035 Katowice.</li>
              <li>• Dane przetwarzamy w celu realizacji umów oraz świadczenia usług warsztatowych.</li>
              <li>• Podstawa prawna: art. 6 ust. 1 lit. a, b oraz f RODO.</li>
              <li>• Masz prawo dostępu, sprostowania, usunięcia i ograniczenia przetwarzania danych.</li>
              <li>• Skargę możesz złożyć do Prezesa UODO (ul. Stawki 2, Warszawa).</li>
              <li>• Kontakt w sprawach RODO: <a href="mailto:slaskimakerspace@gmail.com" className="text-[#FFCC00] underline">slaskimakerspace@gmail.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
